import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { showInputBubble } from '../../shared/input-bubble';

/**
 * Icono de ayuda («?») que, al tocarlo, muestra una burbuja informativa
 * junto a él (misma burbuja que las validaciones, en tono informativo).
 * Para explicar acciones que no son obvias sin ocupar espacio fijo.
 */
@Component({
  selector: 'app-info-tip',
  standalone: true,
  template: `
    <button #tip type="button" class="info-tip" [attr.aria-label]="label" [title]="label" (click)="show($event)">
      <i class="bi bi-question-circle" aria-hidden="true"></i>
    </button>
  `,
  styles: [`
    :host { display: inline-flex; vertical-align: middle; }
    .info-tip { width: 22px; height: 22px; min-height: 0; display: inline-grid; place-items: center; padding: 0; border: 0; border-radius: 50%; color: var(--ts-text-muted, #91a4bf); background: transparent; font-size: .9rem; line-height: 1; cursor: pointer; }
    .info-tip:hover, .info-tip:focus-visible { color: var(--ts-text-blue-250-3); background: var(--ts-bg-blue-400-a12); outline: none; }
  `],
})
export class InfoTipComponent {
  /** Texto de la burbuja. */
  @Input({ required: true }) text = '';
  /** Nombre accesible del botón. */
  @Input() label = 'Más información';
  @ViewChild('tip', { static: true }) tip!: ElementRef<HTMLButtonElement>;

  show(event: Event): void {
    // Nunca envía el formulario que lo contiene ni dispara clics del padre.
    event.preventDefault();
    event.stopPropagation();
    showInputBubble(this.tip.nativeElement, this.text, 'info');
  }
}
